/**
 * Determines if a value is a valid enum value.
 * Example: isEnumValue(LicenseUserSeatType, selectedUserSeatType)
 * @param enumeration The set of enum values.
 * @param value The enum value to check.
 */
export function isEnumValue(enumeration: Dictionary, value: any): boolean {
  return enumeration && Object.values(enumeration).includes(value);
}
